import React from "react";

import BoardFeature from "../features/board/CheckBoardAvailability";

function Board(props) {
  return <BoardFeature {...props} />;
}

export default Board;
